export class UserModel {
  username: string = ""; //Descomentar LFP
  password?: string = ""; //Descomentar LFP
  name: string = "";
  email?: string = "";
  ip?: string = "";
  idPromotor: number;
  rol?: string;
  codOffice?: string;
  numDoc?: number;
  tipDoc?: string = "";
  token?: string = "";
}

export class OauthModel {
  grant_type: string = "password";
  username: string = "";
  password?: string = "";
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user-model.ts